import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { colors } from '@components/shared/colors'
import TopNav from '@components/TopNav'
import Footer from '@components/Footer'
import { GlobalStyle } from '@components/shared'
import TopNavMobile from '@components/TopNavMobile'
import DriveToDownload from '@components/DriveToDownload'
import styled from 'styled-components'
import BackgroundGradient from '@components/BackgroundGradient'

type PropsType = {
}

type DispatchPropsType = {
}

function Home (_props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <>
      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <HtmlHead title={'Dipsea | Short and Sexy Audio Stories'}
        />
      <BGImageContainer>
        <BackgroundGradient
          quadrant={3}
          overlayColor='blue'
        />
        <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true} />
        <TopNavMobile backgroundColor={colors.midnightBlue95} isAssetLoaded={true} />
        <DriveToDownload />
      </BGImageContainer>
      <Footer backgroundColor={colors.midnightBlue} />
    </>
  )
}

const mapStateToProps = (state: AppStateType, ownProps: PropsType): any => {
  return ownProps
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home) as any) as any

const BGImageContainer = styled.div<any>`
  position: relative;
`
